<template>
    <div v-if="uri" class="hero__video hero__video--mood">
        <video-component 
            :uri="uri" 
            autoplay
            muted loop playsinline>
        </video-component>
    </div>
</template>
<script>
import Vue from 'vue'
import VideoComponent from '@app/components/Video.vue'

export default Vue.extend({
    components: {
        VideoComponent
    },

    props: {
        uri: String
    }
})
</script>
